import store from "@/services/store";
import moment from 'moment'
function fecha(items,indexGet) 
{	
	var inicioServicio=items['iniciolabores']
	if(inicioServicio!==null)
	{
		var list_novedad = store.state.crudStore.dataGet.afiliacion_pendientes.data[indexGet].info_afiliacion.id_list_novedad
		var inicioAfiliacion=store.state.crudStore.dataGet.afiliacion_pendientes.data[indexGet].info_afiliacion.ingreso
		var mes_periodo=store.state.crudStore.dataGet.afiliacion_pendientes.data[indexGet].info_afiliacion.mes_periodo
		var ano_periodo=store.state.crudStore.dataGet.afiliacion_pendientes.data[indexGet].info_afiliacion.ano_periodo
		if(list_novedad===1)
		{
			if(items['name']==='Traslado')
			{
				let ano = parseInt(moment(inicioServicio).format('YYYY'))
				let mes = parseInt(moment(inicioServicio).format('MM'))		
				items.mes_periodo=mes
				items.ano_periodo=ano
				mes = store.state.crudStore.lists.list_mes.filter( list => {return list.id.toString()===mes.toString() })[0].name
				ano = store.state.crudStore.lists.list_ano.filter( list => {return list.id.toString()===ano.toString() })[0].name
				return mes+' '+ano
			}
			else 
			{	
				items.mes_periodo=mes_periodo
				items.ano_periodo=ano_periodo	
				let mes = store.state.crudStore.lists.list_mes.filter( list => {return list.id.toString()===mes_periodo.toString() })[0].name
				let ano = store.state.crudStore.lists.list_ano.filter( list => {return list.id.toString()===ano_periodo.toString() })[0].name				
				return mes+' '+ano
			}			
		}
		if(list_novedad===2 || list_novedad===3 || list_novedad===4)
		{
			if(items['name']==='Traslado')
			{
				let ano = parseInt(moment(inicioServicio).format('YYYY'))
				let mes = parseInt(moment(inicioServicio).format('MM'))				
				items.mes_periodo=mes
				items.ano_periodo=ano
				mes = store.state.crudStore.lists.list_mes.filter( list => {return list.id.toString()===mes.toString() })[0].name
				ano = store.state.crudStore.lists.list_ano.filter( list => {return list.id.toString()===ano.toString() })[0].name
				
				return mes+' '+ano
			}
			else 
			{				
				let ano = parseInt(moment(inicioServicio).format('YYYY'))
				let mes = parseInt(moment(inicioServicio).format('MM'))+1				
				if(mes>12) { mes=1;ano= ano+1}

				if(mes<mes_periodo)
				{
					mes=mes_periodo
					ano=ano_periodo
				}
				items.mes_periodo=mes
				items.ano_periodo=ano
				mes = store.state.crudStore.lists.list_mes.filter( list => {return list.id.toString()===mes.toString() })[0].name
				ano = store.state.crudStore.lists.list_ano.filter( list => {return list.id.toString()===ano.toString() })[0].name				
				return mes+' '+ano
			}	
		}
	}
	return null
  }
function invalidradicadoFtn(index,namePath)
{
	let returnValue =  store.state.crudStore.dataGet.afiliacion_pendientes.data[index].datos_afiliado.id_list_estado === 2 ? true : false
	return returnValue
}
export default {
	data(){
		return {
			warningClass: function (items) { return items['datos_afiliado/id_list_estado']==2 ? true : false},
			tableGBoptions: { 
				modals: [
					{
						modal: "Editar",
						icon: "pencil",
						title: "Editar Ficha Afiliado",
						variant: 'primary',
						showFtn: function (value) {
							if(value['datos_afiliado/id_list_novedad']===1){ return true} return false;
						},
					},
				]
			},
			tableGBSearch: ['datos_afiliado/documento','datos_afiliado/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Documento'},
					tbody: { td: ['datos_afiliado/documento',]}
				},
				{
					thead: { th: 'Nombre', sort: null, sortTable: 'datos_afiliado/name', movil: true},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Razón', sort: null, sortTable: 'datos_razon/name' },
					tbody: { td: ['datos_razon/name']}
				},
				{
					thead: { th: 'Inicio L.', },
					tbody: { td: ['info_afiliacion/ingreso'],  class: 'font-weight-bold'}
				},
				{
					thead: { th: 'Pendientes', },
					tbody: { table: {
							value: false,
							tabla: 'servicios_nuevos',
							search: ['servicios_nuevos/name'],
							options:{ 								
								save: {
									icon: "archive",
									btn:"Guardar",
									ftn: "radicadoFtn",
									inputsTable: ["servicios_nuevos/observacion"],
									msj: "¿Desea radicar el servicio?",
									variant: "success",
									invalidFtn: function (invalid,errors,index,namePath,itemsIndex) { return invalidradicadoFtn(index,namePath) ? invalidradicadoFtn(index,namePath) : invalid  },
									movil: false,
								},								
								/*delete: {
									icon: "trash",
									btn:"Eliminar",
									ftn: "eliminarFtn",
									inputsTable: ["servicios_nuevos/nota_delete"],
									msj: "¿ Esta seguro de eliminar el servicio ?",
									variant: "danger",
									invalidFtn: function (invalid,errors,index,namePath,itemsIndex) { 
										if(errors[index+namePath+'servicios_nuevosnota_delete'+itemsIndex]!==undefined && errors[index+namePath+'servicios_nuevosnota_delete'+itemsIndex].length>0)
										{
											return true
										}
										return false
									},
									movil: true
								}*/
							},
							items: [
								{
									thead: { th: 'Servicio', movil: true},
									tbody: {td: ['name', 'id_list']},
								},	
								{
									thead: { th: 'Inicio Labores'},
									tbody: {td: ['iniciolabores'], input: true},
								},		
								{
									thead: { th: 'Próximo Aporte'},
									tbody: {td: ['iniciolabores'], ftn: function Periodo(value,indexGet){ return fecha(value,indexGet)}, class: 'text-danger font-weight-bold'},
								},			
								{
									thead: { th: 'Archivo'},
									tbody: {td: ['archivo'], input: true},
								},						
							]
						},
					}
				},
				{
					thead: { th: 'Radicador', },
					tbody: { td: ['list_users/name'], ftn: function(value) { return value.split(' ')[0]}}
				},
			],			
		
		}
	},
}